module.exports = __webpack_public_path__ + "static/img/RPUPS1248R_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RPUPS1248R_1.png
// module id = z1Je
// module chunks = 0